import { useTerminalEventStream } from './useTerminalEventStream';
import { useTerminalPolling } from './useTerminalPolling';

export function useTerminals(terminalIds: string[], locationId: number) {
  useTerminalEventStream(locationId, terminalIds);
  useTerminalPolling(terminalIds, locationId);
}
